<template>
  <div>
    <AtomLoadingSecondary v-show="showLoadingState"/>
    <div v-show="Object.values(medio.parametros).length">
      <form
        autocomplete="off"
        class="m-form"
        @submit.prevent="updateAcademiaPasarela"
      >
        <h3 class="m-form-title">
          {{ `${$t('mEditionBillingPaymentMethodsEditMethod.title')} ${medio.nombre}` }}
        </h3>
        <div id="params"></div>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethodsEditMethod',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionBillingPaymentMethodsEditMethod.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      isValidPasarela: false,

      medio: {
        descripcion: '',
        nombre: '',
        parametros: {},
        pasarela: ''
      },

      pasarela: {},

      showLoadingState: true
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.pasarela = Object.assign({}, this.$store.getters.getBillingPaymentMethodEdit)
    if (Object.values(this.pasarela).length) {
      this.medio.nombre = this.pasarela.nombre
      this.medio.pasarela = this.pasarela.pasarela_pago
    } else {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}`)
    }
  },

  mounted () {
    this.readPasarelasParametros()
  },

  methods: {
    readPasarelasParametros () {
      this.$services.read('pasarela', 'readPasarelasParametros', {}, [this.pasarela.pasarela_pago, this.academiaId], { 'academia_pasarela_pago': this.pasarela.id_academia_pasarela_pago })
        .then(response => {
          if (typeof response.data === 'object') {
            let form = ''
            form += `<p class="a-input-wrapper-column">`
            form += `<label for="descripcion">${this.$t('mEditionBillingPaymentMethodsEditMethod.inputs.descripcion.label')}</label>`
            form += `<input id="descripcion" class="a-input-primary" name="descripcion" placeholder="${this.$t('mEditionBillingPaymentMethodsEditMethod.inputs.descripcion.placeholder')}" value="${this.pasarela.descripcion}">`
            form += `<small id="descripcion-errormsg" class="display-none text-color-danger">${this.$t('mEditionBillingPaymentMethodsEditMethod.validation.required')}</small></p>`
            for (const param in response.data) {
              form += `<p class="a-input-wrapper-column">`
              form += `<label for="${param}">${response.data[param].label}</label>`
              response.data[param].value
                ? response.data[param].edit
                  ? form += `<input id="${param}" class="a-input-primary" name="${param}" value="${response.data[param].value}">`
                  : form += `<input id="${param}" class="a-input-primary" name="${param}" value="${response.data[param].value}" disabled>`
                : this.pasarela.configuracion[param]
                  ? response.data[param].edit
                    ? form += `<input id="${param}" class="a-input-primary" name="${param}" value="${this.pasarela.configuracion[param]}">`
                    : form += `<input id="${param}" class="a-input-primary" name="${param}" value="${this.pasarela.configuracion[param]}" disabled>`
                  : form += `<input id="${param}" class="a-input-primary" name="${param}" value="">`
              form += `<small id="${param}-errormsg" class="display-none text-color-danger">${this.$t('mEditionBillingPaymentMethodsEditMethod.validation.required')}</small></p>`
              this.medio.parametros[param] = ''
            }
            document.getElementById('params').innerHTML = form
            document.getElementById('params').addEventListener('blur', (event) => {
              if (!event.target.value) {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'block'
                document.getElementById(event.target.id).classList.add('a-input-danger')
              } else {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'none'
                document.getElementById(event.target.id).classList.remove('a-input-danger')
              }
            }, true)
          } else {
            this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}`)
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    setPasarelaCuenta () {
      for (const param in this.medio.parametros) {
        this.medio.parametros[param] = document.getElementById(param).value
        if (document.getElementById(param).value === '') {
          document.getElementById(`${param}-errormsg`).style.display = 'block'
          document.getElementById(param).classList.add('a-input-danger')
        }
      }

      this.medio.descripcion = document.getElementById('descripcion').value
      if (document.getElementById('descripcion').value === '') {
        document.getElementById('descripcion-errormsg').style.display = 'block'
        document.getElementById('descripcion').classList.add('a-input-danger')
      }

      this.isValidPasarela = Object.values(this.medio.parametros).find(param => param === '') === undefined &&
        this.medio.pasarela !== '' && this.medio.descripcion !== ''
    },

    updateAcademiaPasarela () {
      this.setPasarelaCuenta()
      if (this.isValidPasarela && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('academia', 'updateAcademiaPasarela', this.medio, [this.academiaId, this.pasarela.id_academia_pasarela_pago])
          .then(response => {
            this.$alerts.pushAlert('mEditionBillingPaymentMethodsEditMethod', 'updateAcademiaPasarela', 'success')
            this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.readPasarelasParametros()
            this.$alerts.pushAlert('mEditionBillingPaymentMethodsEditMethod', 'updateAcademiaPasarela', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
